import jQuery from 'jquery';

jQuery(($) => {
  'use strict';

  if (window.unreadPaperwork > 0) {
    $('#NewRecords .box:eq(2)').addClass('unread').removeClass('read');
  }

  if (window.unreadInvoices > 0) {
    $('#NewRecords .box:eq(1)').addClass('unread').removeClass('read');
  }

  if (window.unreadRecords > 0) {
    $('#NewRecords .box:eq(0)').addClass('unread').removeClass('read');
  }
});